<template>
  <b-form-radio-group :disabled="disabled" class="pillbox" buttons button-variant="clear" v-model="selected">
    <b-form-radio value="textMode" v-b-tooltip.hover title="Click to edit text"><i class="fas fa-font"></i></b-form-radio>
    <b-form-radio value="moveMode" v-b-tooltip.hover title="Click to move text blocks"><i class="fas fa-arrows-alt"></i></b-form-radio>
  </b-form-radio-group>
</template>

<style lang="scss">
@import '~scss/colors.scss';

.pillbox {
  label.active {
    border-color: $gray-0;
    background: $gray-2;
  }
  label:first-child {
    border-radius: 5px 0 0 5px;
  }
  label:last-child {
    border-radius: 0 5px 5px 0;
  }

}
</style>


<script>
 export default{
   props: ['disabled'],
   data(){
     return {
       selected: 'textMode'
     }
   },
   watch:{
     selected(val){
       if (val === 'textMode'){
         this.$emit('onTextMode');
       }
       else if (val === 'moveMode'){
         this.$emit('onMoveMode');
       }
     }
   }
 }
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/EditModeToggle.vue